import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=2763d347&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=2763d347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763d347",
  null
  
)

export default component.exports